module.exports = __webpack_public_path__ + "iq.70da9a8e0cd87b5f99de.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/iq.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/iq.svg
// module chunks = styles